import angular from 'angular';

angular.module('cloudX').directive('cxUserSelect', function() {
  return {
    restrict: 'E',
    template:
      '<a editable-select="value" \
          e-ng-options="u.id as u.text for u in users | orderBy:\'name\'" \
          onbeforesave="beforeSave({newValue:$data})" \
          onaftersave="handleAfterSave($data)" \
          blur="submit" \
          e-placeholder="{{(\'Unassigned\'|translate)}}" \
          edit-disabled="disabled">' +
      '<span ng-bind="label" ng-class="{\'removed-user\':isInactiveUser()}" ></span>' +
      '<i class="glyphicon glyphicon-pencil" ng-show="!value"></i>' +
      '<span ng-show="invalidUser(true)" class="text-red margin5L"><i class="fa fa-exclamation-triangle margin5R" ></i><span data-translate="Invalid user"></span></span>' +
      '</a>',
    scope: {
      value: '=data',
      beforeSave: '&',
      afterSave: '&',
      disabled: '=?',
    },
    controller: [
      '$scope',
      'dataCache',
      function($scope, dataCache) {
        $scope.users = dataCache
          .getArray('user')
          .filter(x => x.isActive || !x.hidden)
          .map(({ userID, firstName, lastName, isActive }) => ({
            id: userID,
            name: `${firstName} ${lastName}`,
            text: (isActive ? '' : '⚠ ') + `${firstName} ${lastName}`,
            isActive,
          }));
        $scope.findUser = function(userId) {
          if (!userId) return null;
          return dataCache.getObject('user')?.[userId] ?? null;
        };
        $scope.getUserName = function(value) {
          const user = $scope.findUser(value);
          if (!user) return '';
          return `${user.firstName} ${user.lastName}`;
        };
        $scope.handleAfterSave = function(value) {
          $scope.label = $scope.getUserName(value);
          $scope.afterSave({ newValue: value });
        };
        $scope.label = $scope.getUserName($scope.value);

        $scope.isInactiveUser = function() {
          const user = $scope.findUser($scope.value);
          if (!user) return false;
          return !user.isActive;
        };
        $scope.invalidUser = function() {
          const user = $scope.findUser($scope.value);
          if (!user) return false;
          if (user.isActive) return false;
          return !!user.hidden;
        };
      },
    ],
  };
});
